export const PROCESS_COST_OPTIMIZATION_RECOMMENDATION = `
  mutation ProcessCostOptimizationRecommendation($action: CostOptimizationInput!) {
    processCostOptimizationRecommendation(action: $action) {
      data {
        recommendation_id
        status
        last_action_user
        last_action_role
        updated_date
      }
      error {
        statusCode
        message
        code
      }
    }
  }
`
